import { useContext } from "react";
import { contextWeb3 } from "../contexts/ProviderWeb3";

export default function ShowDiscount({ carrito }) {
  const { balanceStore } = useContext(contextWeb3);

  
  const discount = carrito.reduce((acum, p) => {

    // checar si el producto tiene descuento.
    if(p.discount){
      // checar si tiene la cantidad de tokens para el descuento
        if(balanceStore >= p.minimum_amount_discount) {
          // aplicar descuento 120 10
          acum = ((p.price * p.cantidad) * (p.discount))/100;
        }
    }
    
    return acum;
  }, 0);
  return <div >{`- $${discount}`}</div>;
}
